const RISK = 0;
const COMPLIANCE = 1;
const CONFORMITY_LEVEL = 2;
const NOTES = 3;
const RECOMMENDATION = 4;
const CASUAL_FACTOR = 5;
const CORRECTIVE_ACTION = 6;
const COMPLIANCE_INAPPLICABLE_REASONS = 7;
const IS_INAPPLICABLE = 8;

export {
  RISK,
  COMPLIANCE,
  CONFORMITY_LEVEL,
  NOTES,
  RECOMMENDATION,
  CASUAL_FACTOR,
  CORRECTIVE_ACTION,
  COMPLIANCE_INAPPLICABLE_REASONS,
  IS_INAPPLICABLE,
};
